import React, { memo } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
  config: PropTypes.shape({
    disabled: PropTypes.bool,
    handleOnChange: PropTypes.func,
    initialStatus: PropTypes.bool,
    size: PropTypes.string,
    orientation: PropTypes.oneOf(['inline', 'stacked']),
  }),
};

const defaultProps = {
  config: {
    disabled: false,
    initialStatus: false,
    handleOnChange: () => {},
    size: '15',
    orientation: 'inline',
  },
};

const ElevatRadioButtons = ({
  data,
  config: { handleOnChange, initialStatus, size, orientation, disabled },
}) => {
  const radioSize = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <>
      {data.map(([text, selectedStatus], i) => (
        <div
          className={`form-group ${
            orientation === 'inline' ? 'form-check-inline' : ''
          }`}
          key={text}
        >
          {disabled ? (
            <input
              className="rounded-circle mx-2"
              type="radio"
              name="inlineRadioOptions"
              id={`inlineRadio${i}`}
              style={radioSize}
              disabled={disabled}
            />
          ) : (
            <input
              className={`border ${
                initialStatus === selectedStatus
                  ? 'radio-circle border-brand-primary-alert'
                  : 'faded-circle border-icon-link-gray'
              } rounded-circle mx-2`}
              type="radio"
              name="inlineRadioOptions"
              id={`inlineRadio${i}`}
              checked={initialStatus === selectedStatus}
              onChange={() => handleOnChange(selectedStatus)}
              style={radioSize}
              disabled={disabled}
            />
          )}
          <label
            className={`form-check-label ${
              initialStatus === selectedStatus && !disabled
                ? ''
                : 'text-icon-link-gray'
            }`}
            htmlFor={`inlineRadio${i}`}
          >
            {text}
          </label>
        </div>
      ))}
      <style jsx>{`
        .radio-circle,
        .faded-circle {
          -webkit-appearance: none;
          outline: none;
        }
        .radio-circle:hover,
        .faded-circle:hover {
          box-shadow: 0 0 5px 0px var(--brand-primary-alert);
        }
        .radio-circle:before,
        .faded-circle:before {
          content: '';
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
        .radio-circle:checked:before {
          background: var(--brand-primary-alert);
        }
        .faded-circle:checked:before {
          background: var(--icon-link-gray);
        }
      `}</style>
    </>
  );
};
ElevatRadioButtons.propTypes = propTypes;
ElevatRadioButtons.defaultProps = defaultProps;

export default memo(ElevatRadioButtons);
